import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { useGetProductQuery } from "../../../features/api/productApi";
import { useEditModelMutation } from "../../../features/api/modelApi";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";

const UpdateUnit = ({ productModel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [subCat_id, setSubCatId] = useState("");
  const [product_id, setProductId] = useState("");
  const [model, setModel] = useState("");
  const [openingQty, setOpeningQty] = useState(0);

  useEffect(() => {
    if (productModel) {
      setSubCatId(productModel?.subcategory_id);
      setProductId(productModel?.product_id);
      setModel(productModel?.model_name);
      setOpeningQty(productModel?.open_qty);
    }
  }, [productModel]);


  const subCategories = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const [editModel] = useEditModelMutation();
  const handleUpdate = async () => {
    try {
      const newProductModel = {
        id: productModel?.model_id,
        open_qty: openingQty,
        model_name: model,
        subcategory_id: subCat_id,
        product_id: product_id,
      };
      const response = await editModel(newProductModel);
      if (!response?.error) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("updated successfully...!!!");
      } else {
        toast.error(response?.error?.data?.error);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[500px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <div className="w-full">
                      <select
                        value={subCat_id}
                        onChange={(e) => setSubCatId(Number(e.target.value))}
                        className="border pl-1 h-8 bg-slate-50 w-full"
                      >
                        <option>--select--</option>
                        {subCategories?.map((sub) => (
                          <option key={sub?.id} value={sub?.id}>
                            {sub?.sub_catName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <select
                        value={product_id}
                        onChange={(e) => setProductId(Number(e.target.value))}
                        className="border pl-1 h-8 bg-slate-50 w-full"
                      >
                        <option>--select--</option>
                        {products?.map((pro) => (
                          <option key={pro?.id} value={pro?.id}>
                            {pro?.product_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <input
                      type="text"
                      value={model}
                      onChange={(e) => setModel(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Enter Model Name..."
                    />
                    <input
                      type="text"
                      value={openingQty}
                      onChange={(e) => setOpeningQty(Number(e.target.value))}
                      className="border pl-1 h-8 bg-slate-50"
                    />
                  </div>
                  <button
                    onClick={() => handleUpdate()}
                    className="bg-blue-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateUnit;
